function Contact() {
    function handleSubmit(e) {
      e.preventDefault();
      alert("Booking Successful!");
    }
  
    return (
      <section id="contact" className="section">
        <h2>Book Session</h2>
  
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Name" required />
          <input type="email" placeholder="Email" required />
          <select>
            <option>Basic</option>
            <option>Standard</option>
            <option>Premium</option>
          </select>
          <button type="submit">Book Now</button>
        </form>
      </section>
    );
  }
  
  export default Contact;